import { Alert, Button, Card, Checkbox, Col, Form, Input, Radio, Row, Select } from "antd";
import React, {useEffect, useState} from "react";
import { otherFormsOfViolence, typeOfSexualViolence, violenceDocumentStorage } from "../../../constants/incident.constant";
import { getMappedData } from "../util";
const { Option } = Select;
export default function ViolenceInformation(props) {
    const [hideDocumentStorage, setHideDocumentStorage] = useState(true);
    const [hideOtherDocumentStorage, setHideOtherDocumentStorage] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setHideDocumentStorage(props.form.getFieldValue('isDocumented') !== 'yes');
            setHideOtherDocumentStorage(!props.form.getFieldValue('documentStorage')?.includes('Other'));

            if (props.form.getFieldValue('isDocumented') === 'no') {
                props.form.setFieldsValue({documentStorage: ''});
            }
            if (!props.form.getFieldValue('documentStorage')?.includes('Other')) {
                props.form.setFieldsValue({otherDocumentStorage: ''});
            }
        }, 1000);
    }, [props.form.getFieldValue('isDocumented'), props.form.getFieldValue('documentStorage')]);
    const handleIsDocumentedChange = (event) => {
        setHideDocumentStorage(event.target.value === 'no');
        if (event.target.value === 'no') {
            props.form.setFieldsValue({documentStorage: ''});
        }
    };
    const handleIsOtherDocumentedChange = (val) => {
        setHideOtherDocumentStorage(!val.includes('Other'));
        if (!val.includes('Other')) {
            props.form.setFieldsValue({otherDocumentStorage: ''});
        }
    };
  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Form.Item
            label="Type of sexual violence"
            name="typeOfSexualViolence"
            rules={[{ required: true, message: 'Please select at least one option!' }]}
          >
            <Checkbox.Group style={{flexDirection: 'column', paddingLeft: '10px'}}>
              { typeOfSexualViolence.map((item, index) => <Checkbox key={index} value={item.key}>{item.value}</Checkbox>)}
            </Checkbox.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
        <Form.Item
            name="otherTypeOfSexualViolence"
            label="Other forms of sexual violence, please specify"
            rules={[
              {
                required: false,
                message: "please specify",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Form.Item
            label={getMappedData('otherFormsOfViolence')}
            extra={<i>Note: Please do not ask the interviewee directly about specific violations. If they  volunteer the information or have done so previously, please record that information here.</i>}
            name="otherFormsOfViolence"
            rules={[{ required: true, message: 'Please select at least one option!' }]}
          >

            <Checkbox.Group style={{flexDirection: 'column', paddingLeft: '10px'}}>
              { otherFormsOfViolence.map((item, index) => <Checkbox key={index} value={item.key}>{item.value}</Checkbox>)}
            </Checkbox.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="otherFormsOfViolenceNotes"
              label={"Other Notes"}
              rules={[{ required: false, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
        <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
                <Form.Item
                    label={getMappedData('isDocumented')}
                    name="isDocumented"
                    rules={[{ required: true, message: "Please select an option!" }]}
                >
                    <Radio.Group onChange={handleIsDocumentedChange}>
                        <Radio.Button value="yes">Yes</Radio.Button>
                        <Radio.Button value="no">Not yet</Radio.Button>
                    </Radio.Group>
                </Form.Item>
            </Col>
        </Row>
        {!hideDocumentStorage &&
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={24}>
                    <Form.Item
                        name="documentStorage"
                        label="Where are the documents stored?"
                        rules={[
                            {
                                required: true,
                                message: "Please select an option!",
                            },
                        ]}
                    >
                        <Select onChange={handleIsOtherDocumentedChange} mode="multiple">
                            { violenceDocumentStorage.map((item, index) => <Option key={index} value={item.key}>{item.value}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        }
        {!hideOtherDocumentStorage && !hideDocumentStorage &&
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={24}>
                    <Form.Item
                        name="otherDocumentStorage"
                        label="If others, please specify"
                        rules={[
                            {
                                required: true,
                                message: "please specify",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
        }
    </>
  );
}
